import { BASE_URL, AES_KEY } from '../../config'
import Cookies from 'js-cookie';
import AES256 from 'aes-everywhere';
import publicIp from 'public-ip';
import { RESET_STATUS_STATE } from '../../utils/constants/actionTypes';
import store from '../index';
import {SLogout} from '../../config/api'
import bugsnagClient from '../../config/bugsnag';

const Logout = async () => {
	try {
		var tokenRenew = Cookies.get('_kc_rid')
		var tokenRenewDecr = AES256.decrypt(tokenRenew, AES_KEY)

		let res = await fetch(`${BASE_URL}${SLogout}`, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'X-Refresh-Token': tokenRenewDecr,
				'X-Device-IP'		: await publicIp.v4(),
				'X-Device-Name'		: 'No Information',
			},
			body: JSON.stringify({})
		})
		let hasil = await res.json();
		if( res.status === 200 ){
			window.location.href = "/login";
			store.dispatch({ type : RESET_STATUS_STATE });
		} else{
			bugsnagClient.notify(new Error(`Logout.js/ (line 29) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		store.dispatch({ type : RESET_STATUS_STATE });
		bugsnagClient.notify(new Error(`Logout.js/ (line 33) ===> catch - ${err.message}`))
	}
}

export default Logout;